import { PhysicalLocationFilter, Place } from '../types';

const generateAddress = (physicalLocation: PhysicalLocationFilter | Place) => {
  if (
    physicalLocation.address1 ||
    physicalLocation.address2 ||
    physicalLocation.city ||
    physicalLocation.postalCode ||
    physicalLocation.state
  ) {
    const address =
      ' (' +
      physicalLocation?.address1 +
      physicalLocation?.address2 +
      ' ' +
      physicalLocation?.city +
      ' ' +
      physicalLocation?.state +
      ' ' +
      physicalLocation?.postalCode +
      ')';
    return physicalLocation.name + address;
  }
  return physicalLocation.name;
};

export default generateAddress;
